import { InputTextarea, InputTextareaProps } from 'primereact/inputtextarea';
import { classNames } from 'primereact/utils';
import React from 'react';
import { Control, Controller, RegisterOptions } from 'react-hook-form';

type RHFInputTextareaProps = {
    control: Control<any>;
    name: string;
    rules?: RegisterOptions;
    placeholder?: string;
    inputProps?: InputTextareaProps;
};

export const RHFInputTextarea = ({ control, name, rules, placeholder, inputProps }: RHFInputTextareaProps) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field, fieldState }) => (
                <InputTextarea
                    id={field.name}
                    {...field}
                    className={classNames({ 'p-invalid': fieldState.invalid })}
                    placeholder={placeholder}
                    autoResize={true}
                    {...inputProps}
                />
            )}
        />
    );
};
